"use strict";
(function () {
  function init(root) {
    root = root && root.jquery ? root[0] : root || document;
    root.querySelectorAll('.faq__item-question').forEach(function (question, index) {
      if (question.dataset.tcFaqReady) return;
      question.dataset.tcFaqReady = 'true';
      var answer = question.parentElement.querySelector('.faq__item-answer');
      if (!answer) return;
      question.setAttribute('role', 'button');
      question.setAttribute('tabindex', '0');
      question.setAttribute('aria-expanded', 'false');
      answer.id = answer.id || 'tc-faq-answer-' + index;
      question.setAttribute('aria-controls', answer.id);
      answer.style.display = 'none';
      function toggle(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var open = question.getAttribute('aria-expanded') !== 'true';
        question.setAttribute('aria-expanded', String(open));
        question.parentElement.classList.toggle('tab--open', open);
        answer.style.display = open ? 'block' : 'none';
      }
      question.addEventListener('click', toggle, true);
      question.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') toggle(event);
      }, true);
    });
    var search = root.querySelector('#faq-search');
    if (search) search.oninput = function () {
      var term = search.value.trim().toLowerCase();
      root.querySelectorAll('.faq__item').forEach(function (item) {
        var question = item.querySelector('.faq__item-question');
        item.hidden = !!question && !question.textContent.toLowerCase().includes(term);
      });
    };
  }
  Shopify.theme.jsFAQ = { init: init, unload: function () {} };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, {once:true});
  } else init(document);
})();
